import React from "react";
import { useAppConfig } from "../context/AppConfigContext";
import Preloader from "../helper/Preloader";

export default function BootstrapGate({ children }) {
  const { ready } = useAppConfig();

  if (!ready) {
    return <Preloader />; // splash screen / loader
  }

  return children;
}